/* script */
//
//
//
//
//
//
//
//

const __vue_script__ = {
  props: ["time"],
  data() {
    return {
      innerTime: parseInt(this.time) || 900
    };
  },
  computed: {
    hours() {
      return this.format(this.innerTime / (60 * 60));
    },
    minutes() {
      return this.format((this.innerTime / 60) % 60);
    },
    seconds() {
      return this.format(this.innerTime % 60);
    }
  },
  mounted() {
    this.count();
  },
  methods: {
    format(number) {
      return `${Math.floor(number)}`.padStart(2, "0");
    },
    count() {
      if (this.innerTime > 0) {
        setTimeout(() => {
          this.innerTime--;
          this.count();
        }, 1000);
      }
    }
  }
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "countdown" }, [
    _c("img", { attrs: { src: "/static/images/timer.svg" } }),
    _vm._v(" "),
    _c("strong", { staticClass: "mx-3" }, [
      _vm._v(
        _vm._s(_vm.hours) +
          ":" +
          _vm._s(_vm.minutes) +
          ":" +
          _vm._s(_vm.seconds)
      ),
    ]),
    _vm._v(" "),
    _c("small", [_vm._v("Essa oferta irá expirar...")]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4ec4e31a_0", { source: ".countdown {\n  background: #ee6469;\n  color: white;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.countdown img {\n  width: 32px;\n  height: 32px;\n}\n.countdown strong {\n  font-size: 24px;\n}\n\n/*# sourceMappingURL=countdown.vue.map */", map: {"version":3,"sources":["frontend/components/countdown.vue","countdown.vue"],"names":[],"mappings":"AA+CA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AC9CA;ADgDA;EACA,WAAA;EACA,YAAA;AC9CA;ADiDA;EACA,eAAA;AC/CA;;AAEA,wCAAwC","file":"countdown.vue","sourcesContent":["<template>\n  <div class=\"countdown\">\n    <img src=\"/static/images/timer.svg\" />\n    <strong class=\"mx-3\">{{ hours }}:{{ minutes }}:{{ seconds }}</strong>\n    <small>Essa oferta irá expirar...</small>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: [\"time\"],\n  data() {\n    return {\n      innerTime: parseInt(this.time) || 900\n    };\n  },\n  computed: {\n    hours() {\n      return this.format(this.innerTime / (60 * 60));\n    },\n    minutes() {\n      return this.format((this.innerTime / 60) % 60);\n    },\n    seconds() {\n      return this.format(this.innerTime % 60);\n    }\n  },\n  mounted() {\n    this.count();\n  },\n  methods: {\n    format(number) {\n      return `${Math.floor(number)}`.padStart(2, \"0\");\n    },\n    count() {\n      if (this.innerTime > 0) {\n        setTimeout(() => {\n          this.innerTime--;\n          this.count();\n        }, 1000);\n      }\n    }\n  }\n}\n</script>\n\n<style lang=\"scss\">\n.countdown {\n  background: #ee6469;\n  color: white;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 32px;\n    height: 32px;\n  }\n\n  strong {\n    font-size: 24px;\n  }\n}\n</style>",".countdown {\n  background: #ee6469;\n  color: white;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.countdown img {\n  width: 32px;\n  height: 32px;\n}\n.countdown strong {\n  font-size: 24px;\n}\n\n/*# sourceMappingURL=countdown.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/countdown.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__